import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import styles from "./Navbar.module.css";
import { selectUser } from '../redux/slices/userSlice';
import { persistor, store } from '../redux/store';

export default function Navbar() {
  const { pathname } = useLocation();
  const hideNavbar = pathname.startsWith("/chat/");

  // ✅ 聊天頁不顯示 navbar 時，把 nav-height 歸零（避免上方空白）
  useEffect(() => {
    if (hideNavbar) {
      document.documentElement.style.setProperty('--nav-height', `0px`);
      return;
    }
    // 非聊天頁：等 navbar 存在後再量高度
    const nav = document.getElementById('appNavbar');
    const h = nav ? nav.getBoundingClientRect().height : 56;
    document.documentElement.style.setProperty('--nav-height', `${h}px`);
  }, [hideNavbar]);

  const user = useSelector(selectUser);

  const handleLogout = async () => {
    store.dispatch({ type: 'RESET_APP' });
    await persistor.purge();
  };

  if (hideNavbar) return null;

  return (
    <nav
      className={`py-2 navbar fixed-top navbar-expand-lg navbar-dark ${styles.gundamNavbar}`}
      id="appNavbar"
    >
      <div className="container-fluid">
        {/* 左側 Logo */}
        <a className="p-2 navbar-brand d-flex align-items-center gap-2" href="https://heyadigi.com/" target="_blank">
          <span className={styles.logoWrap}>
            <img
              src="https://heyadigi.com/wp-content/uploads/heyadigi-logo-icon.png.webp"
              alt="logo"
              className={styles.logo}
            />
          </span>
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-label="切換導覽"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  'nav-link d-flex align-items-center' + (isActive ? ' active' : '')
                }
              >
                <i className="bi bi-speedometer2"></i> 主控台
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/team-setting"
                className={({ isActive }) =>
                  'nav-link d-flex align-items-center' + (isActive ? ' active' : '')
                }
              >
                <i className="bi bi-gear-wide-connected"></i> 團隊設定
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/team-create"
                className={({ isActive }) =>
                  'nav-link d-flex align-items-center' + (isActive ? ' active' : '')
                }
              >
                <i className="bi bi-people-fill"></i> 建立新團隊
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/assistant-create"
                className={({ isActive }) =>
                  'nav-link d-flex align-items-center' + (isActive ? ' active' : '')
                }
              >
                <i className="bi-magic"></i> 建立代理人
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/file-setting"
                className={({ isActive }) =>
                  'nav-link d-flex align-items-center' + (isActive ? ' active' : '')
                }
              >
                <i className="bi bi-folder2-open"></i> 檔案管理
              </NavLink>
            </li>
          </ul>

          {user?.status === 'authenticated' && (
            <div className={`ms-auto d-flex align-items-center ${styles.rightStack}`}>
              <button
                className={`${styles.logoutBtnMetal} d-flex align-items-center`}
                onClick={handleLogout}
              >
                <img
                  src={user.data.image}
                  alt="image"
                  className="rounded-circle"
                  style={{ width: 20, height: 20 }}
                />
                登出
              </button>
            </div>
          )}
        </div>
      </div>

      {/* 底部紅色能量條 */}
      <div className={styles.accentBar} />
    </nav>
  );
}
